import { useEffect } from "react";
import { appStore } from "src/framework/store/AppStore";
import { ProjetosFormInicialOffGrid } from "src/components/projetos/offgrid/FormInicialOffGrid";
import { EdicaoLayoutOffGrid } from "src/components/projetos/edicao/layouts/EdicaoLayoutOffGrid";

const PAGE_TITLE = 'Clonar projeto off grid'

const ProjetosFormInicialOffGridClonarPage = () => {
  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => {
      appStore.setPageTitle("");
    }
  }, [])
  
  return (
    <EdicaoLayoutOffGrid clonarProjeto>
      <div className="container">
        <div className="row">
          <div className="X12">
            <ProjetosFormInicialOffGrid />
          </div>
        </div>
      </div>
    </EdicaoLayoutOffGrid>
  );
};

export { ProjetosFormInicialOffGridClonarPage };